module.exports = __webpack_public_path__ + "img/services-img6.14892bd0.jpg";